import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Question } from '../../models/underwriter.model';
import { newGuid } from '../question-helper';

@Component({
    selector: 'app-question-radio-form',
    templateUrl: './question-radio-form.component.html',
    styleUrls: ['./question-radio-form.component.scss'],
    standalone: false
})
export class QuestionRadioFormComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Output() questionAnswer = new EventEmitter<Question>();

  uniqueControlName = `radio-form-${newGuid()}`;
  selectedValue = '';
options: any[] = [];
  constructor() {}

  ngOnInit(): void {
    const raw = this.question?.options;
    this.options = raw ? (typeof raw === 'string' ? JSON.parse(raw) : raw) : [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes.question.currentValue;
      this.selectedValue = this.question?.answer ?? '';
    }
  }

  onSelect(value: any): void {
    this.selectedValue = value.answer ?? value;
    this.question.answer = value.answer ?? value;
    this.question.answer_id = value.cent_aq_answer_id ?? null;
    this.questionAnswer.emit(this.question);
  }

  getOptionRows(option: any): { label: string; value: string }[] {
    return Object.keys(option)
      .filter(k => !isNaN(Number(k)))
      .map(k => {
        try { return JSON.parse(option[k]); } catch { return null; }
      })
      .filter(r => r !== null);
  }
}
